import Endpoints = require("../Endpoints");
import type { RequestHandler as RH } from "../RequestHandler";

import type {
	RESTGetAPIAutoModerationRulesResult,
	RESTGetAPIAutoModerationRuleResult,
	RESTPostAPIAutoModerationRuleJSONBody,
	RESTPostAPIAutoModerationRuleResult,
	RESTPatchAPIAutoModerationRuleJSONBody,
	RESTPatchAPIAutoModerationRuleResult,
	RESTDeleteAPIAutoModerationRuleResult
} from "discord-api-types/v10";





class AutoModerationMethods {








	public constructor(public requestHandler: RH) {}
















	public async getAutoModerationRules(guildId: string): Promise<RESTGetAPIAutoModerationRulesResult> {
		return this.requestHandler.request(Endpoints.GUILD_AUTO_MOD_RULES(guildId), {}, "get", "json");
	}

















	public async getAutoModerationRule(guildId: string, ruleId: string): Promise<RESTGetAPIAutoModerationRuleResult> {
		return this.requestHandler.request(Endpoints.GUILD_AUTO_MOD_RULE(guildId, ruleId), {}, "get", "json");
	}





























	public async createAutoModerationRule(guildId: string, data: RESTPostAPIAutoModerationRuleJSONBody & { reason?: string }): Promise<RESTPostAPIAutoModerationRuleResult> {
		return this.requestHandler.request(Endpoints.GUILD_AUTO_MOD_RULES(guildId), {}, "post", "json", data);
	}























	public async editAutoModerationRule(guildId: string, ruleId: string, data: RESTPatchAPIAutoModerationRuleJSONBody & { reason?: string }): Promise<RESTPatchAPIAutoModerationRuleResult> {
		return this.requestHandler.request(Endpoints.GUILD_AUTO_MOD_RULE(guildId, ruleId), {}, "patch", "json", data);
	}

















	public async deleteAutoModerationRule(guildId: string, ruleId: string, reason?: string): Promise<RESTDeleteAPIAutoModerationRuleResult> {
		return this.requestHandler.request(Endpoints.GUILD_AUTO_MOD_RULE(guildId, ruleId), {}, "delete", "json", { reason }) as RESTDeleteAPIAutoModerationRuleResult;
	}
}

export = AutoModerationMethods;
